import React, { Suspense, lazy } from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { LoadingSpinner, Stack } from '../../components';
import MixpanelTracker from '../MixpanelTracker';
import { ROUTES } from '../../constants/routes.constants';

// Lazy load route components for code splitting
const ViewerScheduleRoute = lazy(() => import('../pages/ViewerScheduleRoute'));
const ViewerEventRoute = lazy(() => import('../pages/ViewerEventRoute'));
const PublicCompetitionRoute = lazy(
  () => import('../pages/PublicCompetitionRoute')
);
const PublicScheduleRoute = lazy(() => import('../pages/PublicScheduleRoute'));
const PublicStandingsRoute = lazy(
  () => import('../pages/PublicStandingsRoute')
);

const AppRouter = () => {
  return (
    <Router>
      <MixpanelTracker />
      <Suspense
        fallback={
          <Stack justifyContent="center" alignItems="center" height="100vh">
            <LoadingSpinner />
          </Stack>
        }
      >
        <Routes>
          <Route path={ROUTES.ROOT} element={<ViewerScheduleRoute />}>
            <Route index element={<Navigate to={ROUTES.PUBLIC_MATCHES} />} />
          </Route>
          <Route path={ROUTES.EVENT} element={<ViewerEventRoute />} />
          <Route element={<PublicCompetitionRoute />}>
            <Route
              path={ROUTES.PUBLIC_SCHEDULE}
              element={<PublicScheduleRoute />}
            />
            <Route
              path={ROUTES.PUBLIC_STANDINGS}
              element={<PublicStandingsRoute />}
            />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
